import script from "./details.vue?vue&type=script&setup=true&lang=ts"
export * from "./details.vue?vue&type=script&setup=true&lang=ts"

import "./details.vue?vue&type=style&index=0&id=4653ac20&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4653ac20"]])

export default __exports__